import Colors from '../../../../shared/assets/style/default/color';
import Fonts from '../../../../shared/assets/style/default/fonts';
import Screen from '../../../../shared/utils/screen';
import styled from 'styled-components';

const DescriptionContentTitle = styled.div<React.CSSProperties>`
  color: ${Colors['light']};
  display: -webkit-box;
  font-family: ${Fonts['regular']};
  font-size: ${58 * Screen.widthRatio}px;
  line-height: ${64 * Screen.widthRatio}px;
  margin-top: ${24 * Screen.widthRatio}px;
  overflow: hidden;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 1;
`;

export default DescriptionContentTitle;
